import {
  addMentionEntityIdsFromMarkdown,
  createMentionEntityIdSets,
  toMentionEntityIds,
} from 'src/components/ai/chat/chat-hooks/mention-entity-id-extraction';
import type { MentionEntityIds } from 'src/components/ai/chat/chat-hooks/useMentionEntitiesQuery';

interface ActivityMentionReply {
  text: string;
}

interface ActivityMentionComment {
  replies: readonly ActivityMentionReply[];
  text: string;
}

interface ActivityMentionBody {
  __typename: string;
  comment?: ActivityMentionComment | null;
}

export interface ActivityMentionItem {
  body: ActivityMentionBody;
}

export function extractMentionEntityIdsFromActivityItems(
  items: readonly ActivityMentionItem[]
): MentionEntityIds {
  const allIds = createMentionEntityIdSets();

  for (const item of items) {
    if (!getIsCommentMentionBody(item.body) || !item.body.comment) continue;

    addMentionEntityIdsFromMarkdown(allIds, item.body.comment.text);
    for (const reply of item.body.comment.replies) {
      addMentionEntityIdsFromMarkdown(allIds, reply.text);
    }
  }

  return toMentionEntityIds(allIds);
}

function getIsCommentMentionBody(
  body: ActivityMentionBody
): body is ActivityMentionBody & { __typename: 'CommentActivity' } {
  return body.__typename === 'CommentActivity';
}
